export default {
  email: 'Correo',
  physicalAddress: 'Dirección física',
  webSiteUrl: 'URL de la página web',
  loadingApplication: 'Cargando Aplicación',
  baseUrl: 'URL base',
  redirectionUrl: 'URL de redirección',
  prefix: 'Prefijo',
  pickAApplicationColor: 'Selecciona el color de tu aplicación',
  applicationSuccessfullyUpdated: 'Aplicación actualizada correctamente',
  apiKeyCopied: 'Api Key Copiada',
  apiKeyCopyError: 'Error al copiar el API Key',
  changingPublicKeyWillAffectApps: 'Cambiar la clave pública afectaŕa todas las aplicaciones donde esté en uso. ¿Desea continuar?',
  apiKey: 'Claves de API',
  goToApiDoc: 'Ir a la API Doc',
  publicKey: 'Clave pública',
  privateKey: 'Clave privada',
  generate: 'Generar',
  reNewPublicKey: 'Renovar clave pública',
  deleteInfoField: 'Eliminar campo de información',
  sureToDeleteInfoField: '¿Está seguro que desea eliminar este campo de información?',
  addInfoOfPeopleOfBrand: 'Información adicional de las personas de tu marca',
  sectionAddInfoPeopleOfBrandRequested: 'En esta sección podras agregar información adicional que se le solicitará a las personas de tu marca',
  onlyBeSeenByAppAdministrator: 'Solo puede ser visto por el administrador de la aplicación',
  canBeSeenByPeople: 'Puede ser visto y modificado por las personas desde su perfil',
  shortTextField: 'Campo de texto corto',
  dropDownList: 'Lista desplegable',
  addNewInfoField: 'Agregar nuevo campo de información',
  enterExtraDataId: 'Ingresa el identificador del extradata',
  epayCoCredentials: 'Credenciales Epayco',
  emailVerifyCredentials: 'Credenciales Email List Verify',
  googleCalendar: 'Google Calendar',
  googleConnect: 'Conectar con Google',
  revokeGoogle: 'Revocar Accesos',
  testEnvironment: 'Entorno de pruebas',
  update: 'Actualizar',
  modifyAddInfoField: 'Modificar campo de información adicional',
  createAddInfoField: 'Crear campo de información adicional',
  fieldSuccessfullyDeleted: 'Campo eliminado correctamente',
  fieldName: 'Nombre del campo',
  access: 'Acceso',
  addOptions: 'Agrega las opciones',
  option: 'Opción | Opciones',
  fieldSuccessfullyCreated: 'Campo creado correctamente',
  fieldSuccessfullyUpdated: 'Campo actualizado correctamente',
  application: 'Aplicación | Aplicaciones',
  addAdministrator: 'Agregar administrador',
  administratorsPerPage: 'Administradores por página',
  yes: 'Si',
  no: 'No',
  loadingAdministrators: 'Cargando administradores',
  noAdministratorsRegistered: 'No hay administradores registrados',
  action: 'Acción | Acciones ',
  publicKeyUpdated: 'La clave pública se ha actualizado',
  editAdministrator: 'Editar administrador',
  newAdministrator: 'Nuevo administrador',
  selectAdministratorType: 'Seleccione el tipo de administrador',
  wantAdministratorInactive: '¿Desea que el administrador esté inactivo?',
  selectAdministratorPermissions: 'Selecciona los permisos del administrador',
  addNewAdministrator: 'Agregar nuevo administrador',
  administratorSuccessfullyCreated: 'Administrador creado correctamente',
  administratorSuccessfullyUpdate: 'Administrador modicado correctamente',
  wantToDeleteAdministrator: '¿Desea borrar este administrador?',
  deleteAdministrator: 'Borrar administrador',
  administratorSuccessfullyDeleted: 'Administrador borrado correctamente',
  successfullyColorUpdated: 'Color ha sido actualizado correctamente',
  creditCard: 'Tarjeta de crédito',
  inviteFinancier: 'Invitar financiero | Invitar el financiero',
  billing: 'Facturación',
  addCreditCard: 'Agregar Tarjeta de Crédito',
  loadBalance: 'Cargar saldo',
  usage: 'Uso | Usos | El uso',
  payment: 'Pago | El pago | Pagos | los pagos',
  paymentMethods: 'Métodos de pago',
  completeBusinessDataBeforeAddingCreditCard: 'Complete los datos de su negocio antes de agregar una tarjeta',
  lastDigits: 'Últimos dígitos',
  cardExpirationDate: 'Fecha de vencimiento',
  changeToPrincipal: 'Cambiar a principal',
  creditCardSuccessfullyDeleted: 'Tarjeta eliminada correctamente',
  errorDeletingCreditCard: 'Ocurrió un error al borrar tu tarjeta',
  creditCardPriorityUpdated: 'Prioridad de la tarjeta actualizada',
  dailyUsage: 'Consumo Diario',
  report: 'Reporte',
  recordsPerPage: 'Registros por página',
  loadingRecords: 'Cargando Registros',
  noMovementsRecords: 'No hay registros de movimientos',
  service: 'Servicio',
  amount: 'Cantidad',
  value: 'Valor',
  successfullyMovementsReportDownloaded: 'Reporte de movimientos descargado exitosamente',
  detailedConsumption: 'Consumo detallado',
  approved: 'Aprobado | Aprobados',
  creditCardRechargeWithOutCharge: 'Recarga sin cargo a la tarjeta de crédito',
  methodOf: 'Método de',
  billCollection: 'Cobro de Factura',
  NoAdditionalInfoOfPayment: 'Sin información adicional de pago',
  noPaymentsRecords: 'No hay registros de pagos',
  invoice: 'Factura',
  deposit: 'Depositar',
  makePayment: 'Realizar Pago',
  warning: 'Advertencia',
  rechargeToAvoidBlockingMainFunctions: 'Deberías recargar tu cuenta para evitar el bloque de las funciones principales',
  load: 'Cargar',
  enterIdCardNumber: 'Ingresa tu número de identificación',
  idCardNumber: 'Número de identifiación',
  createCard: 'Crear Tarjeta',
  youMustCompleteCardInformation: 'Debe completar los datos de su tarjeta',
  cardInformationIncorrect: 'Los datos de la tarjeta son incorrectos',
  creditCardSuccessfullyAdded: 'Tarjeta agregada correctamente',
  checkCardDetails: 'Verifique los datos de la tarjeta',
  rejectedCard: 'La tarjeta fué rechazada',
  errorAddingCardPleaseTryAgain: 'Ocurrió un error al agregar tu tarjeta. Intenta nuevamente',
  noDependencies: 'Sin dependencias',
  dependsOn: 'Depende de',
  journeyId: 'Journey ID',
  loadingJourneys: 'Cargando trayectos',
  noJourneysForThisApp: 'No hay trayectos en esta aplicación',
  editJourney: 'Editar Trayecto',
  addNewJourney: 'Agregar nuevo Trayecto',
  dependencies: 'Dependencias',
  selectJourneyColor: 'Selecciona el color del Trayecto',
  chooseAColor: 'Elije un color',
  wantThisDefaultStateWhenSomeoneSignsUp: '¿Desea que este sea el estado por defecto cuando alguien se registre?',
  wantToShowThisStateOnTheSideMenu: '¿Desea mostrar este estado en el menú lateral?',
  loadingJourney: 'Cargando Trayecto',
  addJourney: 'Agregar Journey',
  journeySuccessfullyCreated: 'Trayecto creado exitosamente',
  journeySuccessfullyEdited: 'Trayecto editado exitosamente',
  yellow: 'Amarillo',
  orange: 'Naranja',
  red: 'Rojo',
  purple: 'Morado',
  darkBlue: 'Azul Oscuro',
  lightBlue: 'Azul Claro',
  green: 'Verde',
  wantToDeleteJourney: '¿Desea borrar este Trayecto?',
  deleteJourney: 'Borrar trayecto',
  journeySuccessfullyDeleted: 'Trayecto borrado correctamente',
  clickToSearchOnTheComputer: '...o presiona click para buscar archivos de tu computadora',
  lastName: 'Apellido',
  logInWith: 'Accede con',
  signInWith: 'Reístrate con',
  logInToYourAccount: 'Accede a tu cuenta',
  signIn: 'Registrarse',
  selectColor: 'Seleccionar color',
  selectLogo: 'Seleccionar logo',
  customPhrase: 'Frase personalizada',
  customPhraseOnLogIn: 'Frase personalizada en iniciar sesión',
  customPhraseOnSignIn: 'Frase personalizada en registro ',
  enterSignInMode: 'Ingresa el modo de registro',
  customPhraseOnLogInButton: 'Frase personalizada en botón Acceder',
  customPhraseOnSignInButton: 'Frase personalizada en botón Registrarse',
  hideSocialNetworks: 'Ocultar redes sociales',
  showSignInFirst: 'Mostrar primero el registro',
  showCustomButton: 'Mostrar el botón personalizado',
  buttonText: 'Texto del botón',
  requestData: 'Solicitar datos',
  defaultData: 'Datos predeterminados',
  identification: 'Identificación',
  department: 'Departamento',
  healthProvider: 'Eps',
  bloodType: 'Tipo de sangre',
  day: 'día | días',
  month: 'mes | meses',
  allTheData: 'Todos los datos',
  year: 'año | años',
  range: 'Rango',
  insertTheHtmlTemplateInTheFollowingField: 'Inserta la plantilla html en el siguiente campo',
  templatePreview: 'Previsualizar Template',
  propfilePicUpdates: 'Foto de perfil actualizada',
  /* Forms */
  solo: 'Solo',
  normal: 'Normal',
  needToRefreshBeforeCreateForms: 'Debes recargar antes de crear formularios',
  createForm: 'Crear formulario',
  formsPerPage: 'Formularios por página',
  loadingForms: 'Cargando formularios',
  noFormsRegistered: 'No hay formularios registrados',
  formName: 'Nombre del formulario',
  insertFormOnWebSite: 'Insertar formulario en tu página web',
  personalization: 'Personalización',
  injectableCode: 'Código insertable',
  customYourFormAndInsertGeneratedCodeOnTheNextTab: 'Personaliza tu formulario y luego inserta el código generado en la siguiente pestaña',
  style: 'Estilo',
  responseMessageSent: 'Mensaje de respuesta enviada',
  sendButton: 'Botón de enviar',
  length: 'Tamaño',
  alignment: 'Alineación',
  selectFormColor: 'Selecciona el color de tu formulario',
  divWithKeybeFormsToInsertForm: 'Para insertar un formulario a tu página web, debes crear un elemento DIV con el ID \'keybe-forms\' en el body de tu sitio',
  andThenAddTheNextScriptToTheFooter: ' luego agregar el siguiente Script en el Footer de tu sitio',
  left: 'Izquierda',
  right: 'Derecha',
  center: 'Centro',
  small: 'Pequeño',
  large: 'Grande',
  none: 'Ningúno',
  outlined: 'Contorneado',
  filled: 'Relleno',
  editForm: 'Editar formulario',
  registerForm: 'Formulario de registro',
  obligateLogIn: '¿Obligar inicio de sesión?',
  assignRoleWhenFormIsCompleted: 'Asignar rol cuando se completa el formulario',
  setUpNotificationsEmailForm: 'Configura un correo electrónico donde te llegarán las notificaciones de un envío de formulario',
  emailSubject: 'Asunto del correo',
  sendEmailOnSubmit: 'Enviar correo al recibir Submit',
  sendSmsOnSubmit: 'Enviar SMS al recibir Submit',
  fields: 'Campos',
  addField: 'Agregar campo',
  needToSelectRegisterEmailOrPhone: 'Debe seleccionar el correo o teléfono de registro',
  formSuccessfullyEdited: 'Formulario editado correctamente',
  fieldLength: 'Tamaño del campo',
  required: 'Requerido',
  minFiles: 'Cantidad mínima de archivos',
  linkOfTermsAndConditions: 'Enlace de los términos y condiciones',
  dataHandlingLink: 'Enlace de manejo de datos',
  verificationFields: 'Casillas de verificación',
  filesUpLoad: 'Carga de archivos',
  dataManagement: 'Manejo de datos',
  hide: 'Oculto',
  multipleOption: 'Opción multiple',
  NoRestrictions: 'Sin restricciones',
  fullRow: 'Fila completa',
  halfRow: 'Mitad de la fila',
  newForm: 'Nuevo formulario',
  addNewForm: 'Agregar nuevo formulario',
  formSuccessfullyCreated: 'Formaulario creado correctamente',
  files: 'Archivos',
  fileType: 'Tipo de archivo',
  responses: 'Respuestas',
  responsesPerPage: 'Respuestas por página',
  loadingResponses: 'Cargando respuestas',
  noResponsesYet: 'aún no has recibido una respuesta',
  next: 'Siguiente',
  largeTextField: 'Campo de texto largo',
  registry: 'Registro',
  creatingANewApplicationIsVerySimpleJustFillInTheInformationWeRequestToGoToTheNextStep: 'Crear una nueva aplicación es muy sencillo, simplemente llena los datos que te solicitamos para pasar al siguiente paso (Configurar redes sociales)',
  applicationName: 'Nombre de la aplicación',
  addNewApplication: 'Crear nueva aplicación',
  applicationSuccessfullyCreated: 'Aplicación creada correctamente',
  saveNewBusiness: 'Guardar nuevo negocio',
  thePageYouAreLookingForDoesNotExist: 'La página que buscas no existe',
  address: 'Dirección',
  city: 'Ciudad',
  country: 'País',
  cellPhone: 'Número celular',
  documentType: 'Tipo de identificación',
  darkTheme: 'Tema oscuro',
  lightTheme: 'Tema claro',
  sidebar: 'Menú lateral',
  toolbar: 'Menú superior',
  cardNumber: 'Número de la tarjeta',
  money: 'Dinero',
  connectAccount: 'Conectar Cuenta',
  noRegisteredEmails: 'No hay correos electrónicos conectados',
  selectOutgoingEmail: 'Selecciona correo electrónico saliente',
  showFieldInPeopleFilters: 'Mostrar campo en los filtros de personas',
  clearDataOfAllPeople: 'Borrar datos de todas las personas',
  hideTheField: 'Ocultar el campo',
  deleteAllDataForEveryOne: '¿Desea eliminar todos los datos de todas las personas?',
  justHideTheField: '¿Desea simplemente ocultar el campo?',
  timeZoneInformation: `
  Asignar tu zona horaria es fundamental para que las tareas que te sean
  asignadas y las fechas de creación y actualización de datos se muestren
  correctamente.
  `
}
